// src/knowledge/djs.js
const djs = [
  // Sonra doldururuz
];

export default djs;